<div *ngIf="isVisible" class="left-first-level-container" [@openClose]>

  <div class="pt-4 px-4 flex justify-between">
    <div class="text-xl font-semibold">{{ 'vehicles-list.header' | translate }}</div>
    <!--    <div class="" [routerLink]="['/panel' , 'vehicle']"-->
    <!--         [queryParams]="{mode:'full', id : selectedVehicleId}"-->
    <!--         title="{{'vehicles-list.table-view-mode' | translate}}">-->
    <!--    </div>-->
    <div class="flex actions">
      <button (click)="isVisibleConfigForm = true" class="config-list-btn">
        <i class="pi pi-cog icon"></i>
      </button>
      <app-close-button class="self-center" (close)="onClose()"></app-close-button>
    </div>
  </div>

  <div class="mx-2 mt-1">
    <!-- <app-etoll-balance 
      (heightChanged)="onEtollExpanded($event)"
    ></app-etoll-balance> -->
  </div>

  <div *ngIf="isVisibleConfigForm" class="config-list-container">
    <app-configurator-list-vehicle
      (onSubmit$)="onSubmitConfigForm($event)"
      (onHide$)="isVisibleConfigForm = false"
    ></app-configurator-list-vehicle>
  </div>

  <mat-tab-group animationDuration="0ms" class="grow h-full " (selectedIndexChange)="onSelectedIndexChange()">
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="bg-white text-black label-tab">
          {{ ('labels.vehicles' | translate) | uppercase }} ({{vehicles?.length}})
        </div>
      </ng-template>
      <div class="grid tk-bg-gray-5">
        <vehiclem-vehicle-list
          (onChangeFilters$)="onChangeFilters($event)"
          [vehicles]="vehicles"
          [currentFilter]="currentFilter"
          [selectedVehicleId]="selectedVehicleId"
          [group]="group"
          [listDataTypeVisible]="listDataTypeVisible"
        ></vehiclem-vehicle-list>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="bg-white text-black label-tab">
          TACHO ({{tachoVehicles?.length}})
        </div>
      </ng-template>
      <div class="grid tk-bg-gray-5">
        <vehiclem-vehicle-list
          (onChangeFilters$)="onChangeFilters($event)"
          (onChangeTachoFilters$)="onChangeTachoFilters($event)"
          [vehicles]="tachoVehicles | filterTachoList : filtersSelectedTachoList"
          [tachoFilters]="filtersSelectedTachoList"
          [isTachoView]="true"
          [currentFilter]="currentFilter"
          [selectedVehicleId]="selectedVehicleId"
        ></vehiclem-vehicle-list>
      </div>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <div class="bg-white text-black label-tab">
          ETOLL ({{this.etollVehicles?.length}})
        </div>
      </ng-template>
      <div class="grid tk-bg-gray-5">
        <vehiclem-vehicle-list
          (onChangeFilters$)="onChangeFilters($event)"
          [vehicles]="etollVehicles"
          [currentFilter]="currentFilter"
          [selectedVehicleId]="selectedVehicleId"
          [isEtoll]="true"
        ></vehiclem-vehicle-list>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
